export const FEATURES_DATA = {
    design: {
        titleKey: 'features.design.title',
        cards: [
            {
                image: '/assets/feature/2026-fat-boy-beauty-medalion-ls.jpg',
                titleKey: 'features.design.card1.title',
                descKey: 'features.design.card1.desc'
            },
            {
                image: '/assets/feature/2026-fat-boy-beauty-wheels-ls.jpg',
                titleKey: 'features.design.card2.title',
                descKey: 'features.design.card2.desc'
            },
            {
                image: '/assets/feature/2026-fat-boy-beauty-lighting-ls.jpg',
                titleKey: 'features.design.card3.title',
                descKey: 'features.design.card3.desc'
            }
        ]
    },
    performance: {
        titleKey: 'features.performance.title',
        cards: [
            {
                image: '/assets/feature/2026-fat-boy-beauty-engine-ls.jpg',
                titleKey: 'features.performance.card1.title',
                descKey: 'features.performance.card1.desc'
            },
            {
                image: '/assets/feature/2026-fat-boy-beauty-suspension-ls.jpg',
                titleKey: 'features.performance.card2.title',
                descKey: 'features.performance.card2.desc'
            },
            {
                image: '/assets/feature/2026-fat-boy-beauty-exhaust-ls.jpg',
                titleKey: 'features.performance.card3.title',
                descKey: 'features.performance.card3.desc'
            }
        ]
    },
    innovation: {
        titleKey: 'features.innovation.title',
        cards: [
            {
                image: '/assets/feature/2026-fat-boy-beauty-gauge-ls.jpg',
                titleKey: 'features.innovation.card1.title',
                descKey: 'features.innovation.card1.desc'
            },
            {
                image: '/assets/feature/2026-fat-boy-beauty-usb-ls.jpg',
                titleKey: 'features.innovation.card2.title',
                descKey: 'features.innovation.card2.desc'
            },
            {
                image: '/assets/feature/2026-fat-boy-beauty-brake-ls.jpg',
                titleKey: 'features.innovation.card3.title',
                descKey: 'features.innovation.card3.desc'
            }
        ]
    }
};
